export default {
  not_processed: 'Nicht verarbeitet',
  in_process: 'In Bearbeitung',
  finished_positive: 'Abgeschlossen',
  finished_negative: 'Abgesagt',
}

